<template>
 <div>
   <div class="p-fluid p-formgrid p-grid ">
     <div class="p-field p-col-12 p-md-9"></div>
     <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised btn" @click="generateReport" label="Print" icon="pi pi-print"/>
     </div>
    <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised p-button-danger btn" @click.prevent="$router.back()" label="Cancel"/>
    </div>
  </div>
    <Card>
      <template #content>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4"></div>
          <div class="p-field p-col-12 p-md-4">
            <img :src="$store.state.organisationLogo" class="center"/>
         </div>
         <div class="p-field p-col-12 p-md-4"></div>
       </div>

       <div class="p-fluid p-formgrid p-grid ">
         <div class="p-field p-col-12 p-md-12">
           <label>Date: {{nepaliDate}}</label>
         </div>
         <div class="p-field p-col-12 p-md-12">
           <label>Bill No: {{billNo}}</label>
         </div>
       <div class="p-field p-col-12 p-md-12">
         <label>Customer : {{customerName}}</label>
       </div>
        <div class="p-field p-col-12 p-md-12">
         <label>Contact No: {{customerNumber}}</label>
       </div>
        <div class="p-field p-col-12 p-md-12">
         <label>Address: {{address}}</label>
       </div>
       <div class="p-field p-col-12 p-md-12">
         <label>Product Name: {{productName}}</label>
       </div>
       <div class="p-field p-col-12 p-md-12">
         <label>Quantity: {{quantity}}</label>
       </div>
       <!-- <div class="p-field p-col-12 p-md-12">
         <label>Product Size: {{customerNumber}}</label>
       </div> -->
       <div class="p-field p-col-12 p-md-12">
         <label>Bill Amount: {{billAmount+deliveryCharge}}</label>
       </div>
       <div class="p-field p-col-12 p-md-12">
         <label>Remarks: {{remarks}}</label>
       </div>
       </div>
       <hr/>
       <div class="p-fluid p-formgrid p-grid ">
        
            <div v-if="organisationName == 'Martin Wears'" class="p-field p-col-12 p-md-12" style="text-align: center;">
           <b>Thank you for shopping with us.</b><br/>
           <b>Your satisfaction is our priority.</b><br/>
           <b>If you like our products please mention us on your.</b><br/>
           <b>Instagram story will mean alot.</b>
           <!-- {{orgRemarks===''? 'Thank you for shopping with us.' : orgRemarks}} -->
         </div>
          <div v-else class="p-field p-col-12 p-md-12" style="text-align: center;">
           <!-- <b>Thank you for shopping with us.</b><br/>
           <b>Your satisfaction is our priority.</b><br/>
           <b>If you like our products please mention us on your.</b><br/>
           <b>Instagram story will mean alot.</b> -->
           {{orgRemarks===''? 'Thank you for shopping with us.' : orgRemarks}}
         </div>
       </div>
       <hr/>
       <div class="p-fluid p-formgrid p-grid ">
         <div class="p-field p-col-12 p-md-12">
           <span><b>{{organisationName===''? 'N/A' : organisationName}}</b></span>
         </div>
         <div class="p-field p-col-12 p-md-12">
           <span>{{organisationAddress===''?'N/A':organisationAddress}}</span>
         </div>
         <div class="p-field p-col-12 p-md-12">
           <span>{{organisationContact===''?'N/A':organisationContact}}</span>
         </div>
         <div class="p-grid p-col-12">

         <span style="font-size:10px;">Powered By Raise Tech Pvt.Ltd.</span>

     </div>
       </div>
     </template>
  </Card>
</div>
</template>
<script>
import Button from 'primevue/button'
import Card from 'primevue/card'
export default {
  name: 'PosDeliveryPrint',
  props: ['printData'],
  data() {
    return {
      organisationName: '',
      orgRemarks: '',
      organisationAddress: '',
      organisationContact: '',
      organisationPanVatNo: '',
      customerName: '',
      customerNumber: '',
      billNo: '',
      nepaliDate: '',
      remarks: '',
      // englishDate: null,
      // nepaliDate: null,
      salesList: [],
      narration: '',
      userName: '',
      // subTotalAmount: 0.0,
      // discountAmt: 0.0,
      // vatPercentage: 0.0,
      // vatAmount: 0.0,
      productName: '',
      quantity: 0.0,
      // productCode: '',
      billAmount: 0.0,
      deliveryAmount: 0.0,
      amountInWords: '',
      address: ''
    }
  },
  mounted () {
    this.openVoucherDialog()
  },
  methods: {
    async openVoucherDialog() {
      // // debugger
      if (this.printData === undefined) {
        this.$router.back()
        return
      }
      this.organisationName = this.$store.state.organisationName
      this.organisationAddress = this.$store.state.organisationAddress
      this.organisationContact = this.$store.state.organisationContact
      this.organisationPanNo = this.$store.state.organisationPanVatNo
      this.organisationLogo = this.$store.state.organisationLogo
      this.userName = this.$store.state.user.name
      this.customerName = this.printData.customerName
      this.customerNumber = this.printData.contactNumber
      this.salesList = this.printData.childSalesDetailsDTOList
      this.billAmount = this.printData.billAmount
      this.address = this.printData.deliveryAddress
      this.amountInWords = this.printData.amountInWords
      this.billNo = this.printData.billPrefix
      this.deliveryCharge = this.printData.deliveryAmount
      this.nepaliDate = this.printData.salesDateNepali
      this.remarks = this.printData.remarks
      this.orgRemarks = this.$store.state.orgRemarks
      this.getItemAndUnit()
    },
    getItemAndUnit() {
      for (let i = 0; i < this.salesList.length; i++) {
        this.productName += this.salesList[i].itemName + ','
        this.quantity += parseFloat(this.salesList[i].quantity)
      }
    },
    generateReport () {
      window.print()
    }
  },
  components: {
    Button,
    Card
  }
}
</script>
<style scoped >
@media print {
    .btn {
      display: none;
    }
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// deliveryPrintPage.vue?18c23a5e